var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('gg-flex-menus',{attrs:{"menus":_vm.menuDatas,"default-active":_vm.activeIndex},on:{"select":_vm.menuSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }